import { Navigate, useParams } from 'react-router';
import { ErrorBlock, LoadingBlock } from '../components/states';
import { useBadgeLookup } from '../lib/queries';

/**
 * Where a scanned badge lands. The printed QR carries the badge's own token, so this screen
 * exists only to trade it for the profile it belongs to and get out of the way — the address
 * that stays in the bar afterwards is the ordinary directory one, shareable like any other.
 *
 * Signed out, `/b/...` is remembered and replayed after the magic link (see `lib/returnTo.ts`):
 * scanning somebody's badge and being asked for an email address is forgivable, being dropped
 * on the home screen afterwards is not.
 */
export function BadgeScanPage() {
  const { token = '' } = useParams();
  const lookup = useBadgeLookup(token);

  if (lookup.isPending) {
    return <LoadingBlock label="Reading the badge…" />;
  }

  if (lookup.isError || !lookup.data) {
    return <ErrorBlock message="That badge is not in the directory." />;
  }

  return <Navigate to={`/directory/${lookup.data.personId}`} replace />;
}
